import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import SearchText from "@components/common/search-text";
import { useDebounce, useError, useLoader, useScanRequestsCommunities, } from "@piiqtechnologies/ui-lib";
import { PeekBox, PeekStack } from "@piiqtechnologies/ui-components";
import { CommunitiesListItem, CommunitiesListSort } from "..";
export var COMMUNITY_ORDER_TYPES;
(function (COMMUNITY_ORDER_TYPES) {
    COMMUNITY_ORDER_TYPES["REQUESTS"] = "max";
    COMMUNITY_ORDER_TYPES["ASC"] = "asc";
    COMMUNITY_ORDER_TYPES["DESC"] = "desc";
})(COMMUNITY_ORDER_TYPES || (COMMUNITY_ORDER_TYPES = {}));
export const CommunitiesList = ({ handleCommunitySelected }) => {
    var _a;
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const [getScanRequestsCommunities, scanRequestsCommunities, scanRequestsCommunitiesLoading, scanRequestsCommunitiesError,] = useScanRequestsCommunities();
    const [showCommunityOrder, setShowCommunityOrder] = useState(COMMUNITY_ORDER_TYPES.ASC);
    const [selectedCommunity, setSelectedCommunity] = useState(undefined);
    const [searchKey, setSearchKey] = useState(null);
    const debouncedSearchKey = useDebounce(searchKey, 700);
    useEffect(() => {
        getScanRequestsCommunities({
            search: debouncedSearchKey ? debouncedSearchKey : undefined,
            order: showCommunityOrder,
        });
    }, [debouncedSearchKey, showCommunityOrder]);
    useEffect(() => {
        setLoader(scanRequestsCommunitiesLoading, "scanRequestsCommunitiesLoading");
        return () => setLoader(false, "scanRequestsCommunitiesLoading");
    }, [scanRequestsCommunitiesLoading]);
    useEffect(() => {
        if (scanRequestsCommunitiesError) {
            setError(scanRequestsCommunitiesError === null || scanRequestsCommunitiesError === void 0 ? void 0 : scanRequestsCommunitiesError.message);
        }
    }, [scanRequestsCommunitiesError]);
    useEffect(() => {
        scanRequestsCommunities && handleSelectCommunity(scanRequestsCommunities.data[0]);
    }, [scanRequestsCommunities]);
    const handleCommunityOrder = (order) => {
        setShowCommunityOrder(order);
    };
    const handleSelectCommunity = (community) => {
        setSelectedCommunity(community);
        handleCommunitySelected(community === null || community === void 0 ? void 0 : community.community);
    };
    return (React.createElement(PeekBox, { pt: 3 },
        React.createElement(PeekStack, { spacing: 2 },
            React.createElement(SearchText, { fullWidth: true, placeholder: intl.formatMessage(messages.communitySearch), searchText: searchKey, onChange: setSearchKey }),
            React.createElement(PeekStack, { spacing: 0.1, maxHeight: "1460px" },
                React.createElement(CommunitiesListSort, { setCommunityOrder: (order) => handleCommunityOrder(order), communityOrder: showCommunityOrder }),
                React.createElement(CommunitiesListItem, { communities: scanRequestsCommunities, selectedCommunity: ((_a = scanRequestsCommunities === null || scanRequestsCommunities === void 0 ? void 0 : scanRequestsCommunities.data) === null || _a === void 0 ? void 0 : _a.length) && selectedCommunity, onSelectCommunity: handleSelectCommunity })))));
};
export default CommunitiesList;
